import { IButonOptions } from '@App/ui/crypto_exchange/desktop/components/controls/Button'
import { Context, createContext, useContext } from 'react'

export function useStrictContext<T>(context: Context<T | null>) {
  const value = useContext(context)
  if (value === null) throw new Error('Strict context not passed')
  return value as T
}

export function createStrictContext<T>() {
  return createContext<T | null>(null)
}

export type ConfirmationParams = {
  title?: string
  description?: string
  closeText?: string
  confirmText?: string
  confirmBtnProps?: Partial<IButonOptions>
  cancelBtnProps?: Partial<IButonOptions>
}

export type ConfirmationContext = {
  getConfirmation: (params: ConfirmationParams) => Promise<boolean>
  closeConfirmation: () => void
}

export const confirmationContext = createStrictContext<ConfirmationContext>()

export const useGetConfirmation = () => {
  const { getConfirmation } = useStrictContext(confirmationContext)

  return getConfirmation
}
